import React, { useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { containerStyle } from "../../styles/styles";
import { TableStyles } from "../../styles/table";
import VerticalTabs from "../../tabs";
import TabPanel from "../../common/TabPanel";
import LocalBarIcon from "@material-ui/icons/LocalBar";
import ActiveEmploymentCheck from "../../uis/employementCheck/activeTable";
import PendingEmploymentCheck from "../../uis/employementCheck/pendingTable";

const tabLabels = ["Approved", "Pending"];

const EmploymentCheck = () => {
  const classes = containerStyle();
  const tabClasses = TableStyles();
  const history = useHistory();
  const { activetab } = useParams();

  const tabNameToIndex = {
    0: "approved",
    1: "pending",
  };

  const indexToTabName = {
    approved: 0,
    pending: 1,
  };

  const [tabIndex, setTabIndex] = useState(indexToTabName[activetab]);
  const onChangeTabIndex = (e, newValue) => {
    history.push(
      `/wellness-on-the-go/pre-employment/${tabNameToIndex[newValue]}`
    );
    setTabIndex(newValue);
  };
  return (
    <>
      <div className={tabClasses.filterContainer}>
        <p>
          <LocalBarIcon /> Filter by:
        </p>
      </div>
      <div className={classes.main}>
        <div className={tabClasses.tableRoot}>
          <div className={tabClasses.tabsSection}>
            <VerticalTabs
              tabData={tabLabels}
              tabIndex={tabIndex}
              onTabChange={onChangeTabIndex}
            />
          </div>
          <div className={tabClasses.tabPanelContainer}>
            <TabPanel value={0} index={tabIndex}>
              <ActiveEmploymentCheck />
            </TabPanel>
            <TabPanel value={1} index={tabIndex}>
              <PendingEmploymentCheck />
            </TabPanel>
          </div>
        </div>
      </div>
    </>
  );
};

export default EmploymentCheck;
